module.exports = __webpack_public_path__ + "img/refresh.3cdea5ff.svg";